(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dl-design"] && !Shopify.designMode) return;
  try {
    function diplomatEnhance(root=document){
  root.querySelectorAll('[data-dl-gallery]').forEach(gallery=>{
    if(gallery.dataset.ready)return;gallery.dataset.ready='true';gallery.classList.add('dl-enhanced');
    const panels=gallery.querySelectorAll('[data-gallery-panel]');
    const buttons=gallery.querySelectorAll('[data-gallery-button]');
    const select=i=>{panels.forEach((p,n)=>{p.hidden=n!==i;p.querySelectorAll('video').forEach(v=>{if(n!==i)v.pause()})});buttons.forEach((b,n)=>b.setAttribute('aria-pressed',String(n===i)))};
    buttons.forEach((button,i)=>button.addEventListener('click',()=>select(i)));select(0);
  });
  root.querySelectorAll('[data-dl-variant]').forEach(select=>{
    if(select.dataset.ready)return;select.dataset.ready='true';
    select.addEventListener('change',()=>{const u=new URL(window.location.href);u.searchParams.set('variant',select.value);window.location.assign(u.toString())});
  });
}
diplomatEnhance();document.addEventListener('shopify:section:load',e=>diplomatEnhance(e.target));
  } catch(e) { console.error(e); }
})();

})();
